import React, { useState } from "react";
import { array } from "prop-types";

import CollectionNameTabs from "../../../molecules/CollectionNameTabs";
import NumberedStoryHeadline from "../../../molecules/NumberedStoryHeadline";

import "./organism1.m.css";

const Organism1 = ({ subCollections }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const onTabClick = selectedTabIndex => setSelectedIndex(selectedTabIndex);

  return (
    <div styleName="base">
      <CollectionNameTabs
        collectionList={subCollections.slice(0, 3)}
        selectedIndex={selectedIndex}
        onTabClick={onTabClick}
        className="collection-name"
      />
      <NumberedStoryHeadline
        storyList={subCollections[selectedIndex].items.filter(item => item.type === "story").slice(0, 5)}
        className="numbered-story-headline"
        updatedFont={true}
      />
    </div>
  );
};

Organism1.propTypes = {
  subCollections: array.isRequired
};

export default Organism1;
